import { useNavigate } from 'react-router-dom';
import { Button } from '../../../ui/button';
import { Card, CardContent } from '../../../ui/card';
import { Plus, Calendar, Users, CheckCircle } from 'lucide-react';

export function NoJobs() {
  const navigate = useNavigate();
  const handlePostJob = () => {
    navigate("/homeowner/post");
  };

  return (
    <div className="pt-6 md:pt-0 max-w-3xl mx-auto space-y-12">
      {/* Main Illustration */}
      <Card className="p-12 text-center bg-gradient-to-br from-gray-50 to-gray-100">
        <CardContent className="p-0 space-y-8">
          {/* Large Icon */}
          <div className="relative">
            <div className="w-32 h-32 mx-auto bg-black rounded-full flex items-center justify-center">
              <Calendar className="w-16 h-16 text-white" />
            </div>
            <div className="absolute -top-2 -right-2 w-12 h-12 bg-white border-4 border-gray-100 rounded-full flex items-center justify-center">
              <Plus className="w-6 h-6 text-black" />
            </div>
          </div>

          {/* Main Message */}
          <div className="space-y-4">
            <h2 className="text-4xl font-bold text-black">You have no jobs yet</h2>
            <p className="text-xl text-gray-600 max-w-xl mx-auto">
              Ready to get help with your property? Post your first job and connect with reliable local helpers.
            </p>
          </div>

          {/* Call to Action */}
          <Button
            size="lg" 
            onClick={handlePostJob}
            className="px-6 py-3 sm:px-12 sm:py-6 sm:text-xl text-sm bg-black hover:bg-gray-800 text-white"
          >
            <Plus className="w-3 h-3 sm:w-6 sm:h-6 mr-3" />
            Post Your First Job
          </Button>
        </CardContent>
      </Card>

      {/* Feature Cards */}
      <div className="grid md:grid-cols-3 gap-6">
        <Card className="p-6 text-center hover:shadow-lg transition-all duration-300">
          <CardContent className="p-0 space-y-4">
            <div className="w-16 h-16 mx-auto bg-black rounded-full flex items-center justify-center">
              <Plus className="w-8 h-8 text-white" />
            </div>
            <div className="space-y-2">
              <h3 className="text-xl font-semibold">Easy Posting</h3>
              <p className="text-gray-600">
                Post your service needs in just a few minutes with our simple wizard
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="p-6 text-center hover:shadow-lg transition-all duration-300">
          <CardContent className="p-0 space-y-4">
            <div className="w-16 h-16 mx-auto bg-black rounded-full flex items-center justify-center">
              <Users className="w-8 h-8 text-white" />
            </div>
            <div className="space-y-2">
              <h3 className="text-xl font-semibold">Find Helpers</h3>
              <p className="text-gray-600">
                Connect with trusted local helpers in your neighborhood
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="p-6 text-center hover:shadow-lg transition-all duration-300">
          <CardContent className="p-0 space-y-4">
            <div className="w-16 h-16 mx-auto bg-black rounded-full flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-white" />
            </div>
            <div className="space-y-2">
              <h3 className="text-xl font-semibold">Get It Done</h3>
              <p className="text-gray-600">
                Track progress and confirm completion when the job is finished
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Steps Guide */}
      <Card className="p-8 bg-black text-white">
        <CardContent className="p-0">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-center">How it works</h3>
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div className="space-y-3">
                <div className="w-12 h-12 mx-auto bg-white text-black rounded-full flex items-center justify-center font-bold text-xl">
                  1
                </div>
                <h4 className="text-xl font-semibold">Post a Job</h4>
                <p className="text-gray-300">
                  Tell us what you need help with and when
                </p>
              </div>
              <div className="space-y-3">
                <div className="w-12 h-12 mx-auto bg-white text-black rounded-full flex items-center justify-center font-bold text-xl">
                  2
                </div>
                <h4 className="text-xl font-semibold">Get Matched</h4>
                <p className="text-gray-300">
                  We'll connect you with available helpers nearby
                </p>
              </div>
              <div className="space-y-3">
                <div className="w-12 h-12 mx-auto bg-white text-black rounded-full flex items-center justify-center font-bold text-xl">
                  3
                </div>
                <h4 className="text-xl font-semibold">Job Complete</h4>
                <p className="text-gray-300">
                  Confirm completion and rate your helper
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}